import { useSelector } from 'react-redux';

import { mapItemsForProviderServices } from './group-hooks-utils';
import { CountryConfigNames } from '../../../contexts/country-config-context/country-config-enums';
import { useCountryConfig } from '../../../hooks/use-country-config';
import { useGetSellerProviderName } from '../../../hooks/use-get-seller-provider-name';
import Global from '../../../store/global-selectors';
import GetProviderDisplayName from '../../data-driven-logo/get-provider-display-name';

export const useProviderGroups = (availableServices, selectedItem, getDisplayName) => {
  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const [, preferredProviderConfig] = useCountryConfig(CountryConfigNames.PreferredProvider);
  const preferredLabelProviderId = preferredProviderConfig?.labelProviderId ?? null;

  const sortedSellerLabelProviders = [...sellerLabelProviders].sort((a, b) => {
    if (preferredLabelProviderId) {
      const aIsPreferred = a.labelProviderId === preferredLabelProviderId;
      const bIsPreferred = b.labelProviderId === preferredLabelProviderId;

      if (aIsPreferred && !bIsPreferred) {
        return -1;
      }
      if (!aIsPreferred && bIsPreferred) {
        return 1;
      }
    }

    return 0;
  });
  const getSellerProviderName = useGetSellerProviderName();
  const services = availableServices.filter((service) => !service.isHidden);

  return sortedSellerLabelProviders.map((provider) => {
    const { sellerLabelProviderId } = provider;
    const servicesByLabelProviderId = services.filter((service) => service.sellerLabelProviderId === provider.sellerLabelProviderId);
    const items = mapItemsForProviderServices(servicesByLabelProviderId, selectedItem);
    return {
      groupId: sellerLabelProviderId,
      name: getDisplayName ? GetProviderDisplayName(provider.labelProviderId) : getSellerProviderName(provider),
      accountNickname: provider.name || null,
      items,
    };
  });
};
